var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-content",style:({
		backgroundColor: _vm.widget.settings.bgColor,
		fontSize: `${_vm.widget.settings.fontSize}px`,
		color: _vm.widget.settings.color
	})},[_c('marquee',{staticClass:"marque",attrs:{"scrollamount":"10"}},[_vm._v("\n\t\t"+_vm._s(_vm.widget.settings.text)+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }